// extracted by mini-css-extract-plugin
module.exports = {"LabeledIcon":"LabeledIcon_LabeledIcon__oS5mq","Icon":"LabeledIcon_Icon__94D4S","Label":"LabeledIcon_Label__k_qad"};